import React from "react";
import { useLocation, useParams } from "react-router-dom";
import {CONF_SETTINGS_EDIT, CONF_SETTINGS_ADD, CONF_SETTINGS_UPDATE } from "routes/ApiEndpoints";
import FormBuilder from "components/common/services/form/FormBuilder";
import { validateMultiSelectField, validateRequired } from "components/common/services/ValidationService";
import { CREATE_BUSINESS_UNIT } from "routes/RouteConstants";
import { t, translate } from "components/CentralDataMangement/translation/Translation";
import AccessControl from "components/common/services/RolesAndPermissions/AccessControl";


interface IdProps {
  id?: number | string;
}

const BusinessUnit: React.FC<IdProps> = ({ id }) => {
  const location = useLocation();
  const path = location.pathname;
  const { id: routeId } = useParams<{ id: string }>();
  const isEditMode = location.pathname.includes('edit');
  const FormValidation = {
    unitName: [validateRequired],
    empCategory:[validateMultiSelectField],
    coeff_name: [validateMultiSelectField],
  };

  const permissionType = id ? "update" : "create";
  const permissionObject: any = {
    permission: "Business units",
  };
  permissionObject[permissionType] = true;
  return (
    <AccessControl
      requiredPermissions={[permissionObject]}
      renderNoAccess={true}
    >
      <FormBuilder
        microService="central-data-management"
        actionType={path === CREATE_BUSINESS_UNIT ? "create" : "edit"} // action type create or edit
        entryId={id || routeId} // required only if actionType is edit
        getDataAPI={CONF_SETTINGS_EDIT} //required only if actionType is edit
        SaveDataAPI={path === CREATE_BUSINESS_UNIT ? CONF_SETTINGS_ADD : CONF_SETTINGS_UPDATE} //Post's data to this endpoint
        formName={"BusinessUnit"} //Form name
        title={path === CREATE_BUSINESS_UNIT ? t("Add business unit") : t("Edit business unit")} // Form title
        redirect={-1} // After submit redirect to this screen/route
        validationRules={FormValidation} //Validation rules to validate form on submit
        type='businessUnit'
        disableField = {isEditMode ? ['empCategory', 'coeff_name'] : []}
      />
    </AccessControl>
  );
};

export default translate(BusinessUnit);
